$(document).ready(function () {
    $(".downloadTab_text:first-child ").addClass('downloadTab_active');
    $(".downloadCollection[data-id='one']").show();
    // 首先确保第一个父标签中的 .downloadCollection_bottom1 显示
    $(".downloadCollection[data-id='one']").each(function () {
        // 找到当前元素最近的父标签 .downloadCollection_conter
        var $parentConter = $(this).closest('.downloadCollection_conter');
        // 输出找到的父级元素，以便确认选择正确
        // 示例：添加一个类名或者进行其他操作
        $parentConter.addClass('downloadCollection_conter1');
    });
    $('.downloadCollection_conter1').each(function () {
        $('.downloadCollection_conter1').first().addClass('highlight');
        $('.highlight').children('.downloadCollection').find('.downloadCollection_bottom1').show();
        $('.highlight').children('.downloadCollection').find('.downloadCollection_title').addClass('downloadCollection_iconActive');

    })
    // 判断是否为手机端
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    var swiper
    // 如果是手机端，则添加相应的类名
    if (isMobile) {
        $('.downloadTab').addClass('swiper');
        $('.downloadTab').addClass('downloadTab_swiper');
        $('.downloadTab_content').addClass('swiper-wrapper');
        $('.downloadTab_text').addClass('swiper-slide');
        swiper = new Swiper(".downloadTab_swiper", {
            slidesPerView: 2.5,
            spaceBetween: 8,
            slideToClickedSlide: true,
        });

    }
})
$('.downloadTab_text').click(function () {
    var id = $(this).data('id');
    $(this).addClass('downloadTab_active').siblings().removeClass('downloadTab_active');
    $('.downloadCollection_conter').each(function () {

        if ($(this).children('.downloadCollection').data('id') == id) {
            $(this).addClass('downloadCollection_conter1');
            $(this).children('.downloadCollection').show();
            $('.downloadCollection_conter1').each(function () {
                $('.downloadCollection_conter1').first().addClass('highlight');
                $('.highlight').children('.downloadCollection').find('.downloadCollection_bottom1').show();
                $('.highlight').children('.downloadCollection').find('.downloadCollection_title').addClass('downloadCollection_iconActive');

            })
        } else {
            $(this).removeClass('downloadCollection_conter1');
            $(this).removeClass('highlight');
            $(this).children('.downloadCollection').hide();
            $(this).find('.downloadCollection_bottom1').hide();
            $(this).find('.downloadCollection_title').removeClass('downloadCollection_iconActive');
        }
    });
})
$('.downloadCollection_title').click(function () {
    var $this = $(this);
    var $parent = $this.closest('.downloadCollection');
    var $content = $parent.find('.downloadCollection_bottom1');

    // 如果当前内容可见，则隐藏它并移除 active 类
    if ($content.is(":visible")) {
        $this.removeClass('downloadCollection_iconActive');
        $content.slideUp();
    } else {
        // 否则，显示当前内容并隐藏其他内容
        $this.closest('.downloadCollection_conter1').siblings().find('.downloadCollection_title').removeClass('downloadCollection_iconActive');
        $this.closest('.downloadCollection_conter1').siblings().find('.downloadCollection_bottom1').slideUp();

        $this.addClass('downloadCollection_iconActive');
        $content.slideDown();
    }
});


$('.downloadCollection_listVideo').click(function () {
    let videoUrl = $(this).attr('data-url');
    let iframeId = $(this).attr('data-id');
    let iframeUrl = `https://www.youtube.com/embed/${iframeId}?controls=1&mute=1&autoplay=1`
    $('.videoShadow').css('display', 'flex');
    $('.max-w-full').css("overflow", "hidden")
    if (videoUrl != '' && iframeId == '') {
        $('#activity_allVideo').attr('src', videoUrl)
        $('#activity_allVideo').show();
        $('#activity_allIframe').hide();
    } else if (videoUrl == '' && iframeId != '') {
        $('#activity_allIframe').attr('src', iframeUrl)
        $('#activity_allVideo').hide();
        $('#activity_allIframe').show();
    }
})

$('.videoShadow').click(function () {
    $('.videoShadow').hide();
    $('#activity_allVideo').attr('src', '');
    $('#activity_allIframe').attr('src', '');
    $('.max-w-full').css("overflow", "auto")
})
$('.closureIcon').click(function () {
    $('.videoShadow').hide();
    $('#activity_allVideo').attr('src', '');
    $('#activity_allIframe').attr('src', '');
    $('.max-w-full').css("overflow", "auto")
})
